import { Room } from '@spike/room-model';

type WeightRangeInfo = {
    min?: number;
    max?: number;
};

export const getWeightRangeInfo = (room?: Room): WeightRangeInfo | null => {
    if (!room?.rules) return null;

    const weightRangeRule = room.rules.find(r => r.ruleTypeId === 4);
    if (!weightRangeRule) return null;

    try {
        const data = JSON.parse(weightRangeRule.data);
        return {
            min: typeof data?.weightFrom === 'number' ? data.weightFrom : undefined,
            max: typeof data?.weightTo === 'number' ? data.weightTo : undefined
        };
    } catch {
        return null;
    }
};
